import LoginPage from "./pages/login/LoginPage";
import React, {Component} from 'react';
import {BrowserRouter} from 'react-router-dom';
import App from "./App";
import AmplifyConfig from './AmplifyConfig';
import {Authenticator} from 'aws-amplify-react';
import styled from "styled-components";
import backgroundImg from "./assets/prognos_grafiskt_element.png";
import NewPasswordPage from "./pages/login/NewPasswordPage";
import ForgotPasswordPage from "./pages/login/ForgotPasswordPage";
import {Amplify} from "@aws-amplify/core";

Amplify.configure(AmplifyConfig);

const Container = styled.div`
  height: 100%;
  background-image: url(${backgroundImg});
  background-repeat: no-repeat;
  background-size: cover;
  background-color: #bedce6;
`;

class Root extends Component {

    render() {
        return (
            <BrowserRouter>
                <Container>
                    <Authenticator hideDefault={true}
                                   amplifyConfig={AmplifyConfig}>
                        <LoginPage/>
                        <NewPasswordPage/>
                        <ForgotPasswordPage/>
                        <App/>
                    </Authenticator>
                </Container>
            </BrowserRouter>
        )
    }
}

export default Root;
